<template>
  <div>
    <div class="flex justify-center vs-row" style="padding:1rem;">
      <div class="vs-col" v-for="(master,index) in cautionNoteList" :key="index" style="margin:0.2rem;">
        <vs-chip 
          style="border-radius:5px;height:3rem;width:100%;margin:0 0.2rem;" 
          :color="'#' + master.color.color_hex "
        >
          {{ master.name }}
        </vs-chip>
      </div>
    </div>
    <vs-button
      style="visibility:hidden;"
      v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
    >
    </vs-button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    cautionNoteList() {
      const cautionNoteList = this.valueMap && this.valueMap.value ? this.valueMap.value : [];
      return cautionNoteList.map(x => {return {color:x.tag.color, name:x.tag.name}});
    },
  },
  methods: {
    initData() {
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.selectedId;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
</style>

